import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';
import CloseIcon from 'mdi-react/CloseCircleOutlineIcon';

export const AppliedFilters = styled.div`
  margin-top: ${layout.measurements.spacing050};

  ${media.largeUp`
  margin-top: 0;
`}
`;

export const AppliedFilter = styled(Clickable)`
  align-items: center;
  background: ${({ theme }) => theme.buttons.primary.bg};
  border-radius: ${layout.borderRadius};
  color: white;
  cursor: pointer;
  display: inline-flex;
  font-size: ${layout.measurements.fontSizeSmall};
  margin: 0 ${layout.measurements.spacing025} ${layout.measurements.spacing025}
    0;
  max-width: 250px;
  padding: ${layout.measurements.spacing050};
  text-align: left;

  ${media.largeUp`
  font-size: ${layout.measurements.fontSizeSmall};
`}
`;

export const AppliedFilterText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AppliedFilterIcon = styled(CloseIcon).attrs({ size: 14 })`
  flex: 0 0 auto;
  margin-left: ${layout.measurements.spacing025};
`;

export const AppliedFiltersTitle = styled.span`
  margin-right: ${layout.measurements.spacing100};
`;
